import { Dialog } from "@mui/material";
import intl from "react-intl-universal";
import { ModalCloseButton } from "../../../Components/Molecules/ValutDialog";
import { StablesDepositarContent } from "./StablesDepositarContent";

const MODAL_PAPER_CLASS = "!rounded-2xl !shadow-card app-card !m-4 !flex !flex-col !max-h-[90vh]";

export const StablesDepositarModal = ({ open, onClose, initialAssetId = null }) => {
  const handleDialogClose = (_, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      disableEscapeKeyDown
      fullWidth
      maxWidth="md"
      PaperProps={{ className: MODAL_PAPER_CLASS }}
    >
      <div className="relative flex min-h-0 flex-1 flex-col">
        <ModalCloseButton onClick={onClose} className="absolute right-3 top-3 z-10" />

        <div className="flex-1 overflow-y-auto px-5 pb-5 pt-6 sm:px-6">
          <h2 className="pr-8 text-lg font-bold text-brand-dark dark:text-gray-100">
            {intl.get("stables.deposit")}
          </h2>

          <div className="mt-4">
            <StablesDepositarContent isActive={open} initialAssetId={initialAssetId} />
          </div>
        </div>
      </div>
    </Dialog>
  );
};
